<template>
  <el-dialog
    title="选择导购"
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :before-close="cancelAction"
    append-to-body
    width="1100px"
  >
    <!-- 查询区 -->
    <ul class="search-btn">
      <li>
        <span class="m-r-6">工号</span>
        <el-input
          v-model="params.employee_number"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <span class="m-r-6">门店</span>
        <el-input
          v-model="storeNum"
          placeholder="全部门店"
          class="input-m m-r-6"
          :disabled="true"
          style="min-width: 250px"
        >
          <div slot="append">
            <el-link
              type="primary"
              style="margin-right: 10px"
              @click="storeVisible = true"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              @click="clearStore"
            >
              重置
            </el-link>
          </div>
        </el-input>

        <!-- 编辑门店 -->
        <SpStoreSelect
          v-model="storeVisible"
          :select-data="selectStoreData"
          @chooseStore="chooseStore"
        />
      </li>
      <li>
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
      </li>
    </ul>

    <div style="margin-bottom: 15px" />
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="guideData"
      tooltip-effect="dark"
      :row-key="getRowKeys"
      @select="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="50"
      />
      <el-table-column
        prop="employee_number"
        width="200px"
        label="员工工号"
      />
      <el-table-column
        prop="salesperson_name"
        width="200px"
        label="员工姓名"
      />
      <el-table-column
        prop="store_name"
        width="200px"
        label="所属门店"
      />
      <el-table-column
        prop="store_bn"
        width="200px"
        label="门店编号"
      />
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.employee_status === 2">编外</span>
          <span v-else>员工</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="tr" />
    <div
      slot="footer"
      class="dialog-footer select-footer"
    >
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :total="total_count"
          :current-page="params.page"
          :page-size="params.page_size"
          @current-change="handleCurrentChange"
        />
      </div>
      <div>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="saveStoreAction"
        >
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SpGuideSelect',
  model: {
    prop: 'guideVisible',
    event: 'guideVisibleChange'
  },
  props: {
    guideVisible: {
      // 展示选择器的模态框
      type: Boolean,
      default: false
    },
    submitLoading: {
      //提交的加载
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      guideData: [],
      multipleSelection: [],
      total_count: 0,
      params: {
        page: 1,
        page_size: 10,
        employee_number: ''
      },
      storeNum: null,
      storeVisible: false,
      selectStoreData: []
    }
  },
  computed: {
    showDialog () {
      return this.guideVisible
    }
  },
  watch: {
    guideVisible (newVal, oldVal) {
      if (newVal) {
        this.getNewsList()
      }
    }
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.salesperson_id
    },

    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getNewsList()
    },

    // 查询
    searchList () {
      this.params.page = 1
      this.getNewsList()
    },

    // 关闭模态框
    cancelAction () {
      this.$refs.multipleTable.clearSelection()
      this.multipleSelection = []
      this.$emit('guideVisibleChange', false)
    },
    // 获取列表
    async getNewsList () {
      this.loading = true
      const data = await this.$api.salesperson.getSalesmanList(this.params)
      if (data) {
        this.loading = false
        this.guideData = data.list
        this.total_count = data.total_count
      }
    },

    // 选择
    selectGuideList (row) {
      this.$refs.multipleTable.clearSelection()
      this.multipleSelection = []
      this.$emit('selectGuide', row)
    },

    // table表格选择
    handleSelectionChange (selection, row) {
      this.$refs.multipleTable.clearSelection()
      this.multipleSelection = []
      if (selection.length === 0) {
        // 判断selection是否有值存在
        return
      }
      if (row) {
        this.multipleSelection = row
        this.$refs.multipleTable.toggleRowSelection(row, true)
      }
    },
    // 保存绑定
    saveStoreAction () {
      this.selectGuideList(this.multipleSelection)
    },

    //重置门店选择
    clearStore () {
      this.selectStoreData = []
      this.storeIds = []
      this.storeNum = ''
      this.params.store_id = []
    },
    // 选择门店
    chooseStore (selectdata, storeids) {
      console.log(selectdata, 'selectdataselectdata')
      this.storeIds = storeids
      let storeBns = []
      selectdata.forEach((v) => {
        storeBns = storeBns.concat(v.store_id)
      })
      this.selectStoreData = selectdata
      this.params.store_id = storeBns
      this.storeNum = '已选择' + selectdata.length + '家门店'
      this.storeVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.select-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.select-btn {
  font-size: 24px;
  color: #ccc;
  cursor: pointer;
}
.selected-btn {
  color: #409eff;
}
::v-deep {
  .el-table {
    .el-table-column--selection.is-leaf .cell {
      display: none;
    }
  }
}
.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
